import { BillingCycleTypes } from '../../domain/invoice';
import { SortItem } from './member.dashboard.license.response';

export class AbandonedCartItem {
    ID: number;
    ProductID: number;
    BillingCycle: BillingCycleTypes;
    CartID: string;
    DateTimeCreated: Date;
    DateTimeUpdated: Date;
    IP: string;
    RedirectID: number;
    DateTimeRedirectClicked: Date;
    FirstName: string;
    LastName: string;
    Email: string;
    ConfirmEmail: string;
    Company: string;
    Phone: string;
    CCName: string;
    Address: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
    LastSent: Date;
    Initials: string;
    isHidden: boolean;

    public static FixDates(item: AbandonedCartItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
        item.DateTimeUpdated = new Date(item.DateTimeUpdated);
        item.DateTimeRedirectClicked = new Date(item.DateTimeRedirectClicked);

    }

}

export class AbandonedCartItemArray extends Array<AbandonedCartItem> {
    public LastSort: SortItem;

    constructor(...items: AbandonedCartItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AbandonedCartItemArray.prototype);
    }

    public static FixDates(item: AbandonedCartItemArray) {
        item.forEach(x => AbandonedCartItem.FixDates(x));
    }

}
